import { Observable, Subject } from 'rxjs';
import { FileDetailsDTO, DocumentClassDTO, SignatureType, SignatureMode, SignatureValidationCode, SignatureFormatDTO } from '../../app/api/plyca-dtos';

export enum SignatureStatus {
  OK,
  ERROR,
  CANCELLED
}

export interface SignatureProviderResponse {
  status: SignatureStatus;
  errorMessage: string;
}

export class SignatureProviderConfig {
  btnName: string;
  btnIcon: string
  btnClass: string;
}

/**
 * Definicion y configuracion de un proveedor de firma
 */
export interface SignatureProvider {
  type: SignatureProviderType,
  config: SignatureProviderConfig;
}

export enum SignatureProviderType {
  AFIRMA = 'AFIRMA',
  PASSWORD_PROVIDER = 'PASSWORD_PROVIDER',
  MOCK = 'MOCK'
}
export enum AFirmaAlgorithmType {
  SHA512withRSA = 'SHA512withRSA',
  SHA384withRSA = 'SHA384withRSA',
  SHA256withRSA = 'SHA256withRSA',
  SHA1withRSA = 'SHA1withRSA'
}

export class SignatureRequest {
  file: FileDetailsDTO;
  /**
   * indica el certificado a usar en la firma
   */
  certificate: Certificate;
  documentClass: DocumentClassDTO;
  signatureFormat: SignatureFormatDTO;
  comment: string;
  provider: SignatureProviderType;
  // para reaccionar tras firma de un fichero
  subscription = new Subject<SignatureResponse>();
}

export class SignatureResponse implements SignatureProviderResponse {
  request: SignatureRequest;
  file: FileDetailsDTO;
  signatureStatus: SignatureValidationCode;
  status: SignatureStatus;
  errorMessage: string;
}

export class Certificate {
  identifier: string;
  certificateB64: string;
  validFrom: Date;
  validTo: Date;
  subject: string;
  issuer: string;
  password: string
}

export class CertificateSelectionResponse implements SignatureProviderResponse {
  certificate: Certificate;
  status: SignatureStatus;
  errorMessage: string;
}

/**
 * Interface que debe cumplir la integración con un software
 * de generación de firmas
 */
export interface SignatureProviderService {
  /*+
  * Metodo que indica si el proveedor esta hailitado para ser utilizado
  */
  isEnabled(): boolean;
  /**
   * Metodo de comprobacion de la conexion
   */
  check(): Observable<SignatureStatus>;

  /** Metodo de firma de un fichero
   *
   * @param request datos de firma
   * @returns resultado de la firma realizada
   */
  sign(request: SignatureRequest): Observable<SignatureResponse>;
  /**
   * Metodo de encargado de la selección de un certificado
   *
   * @param authorization
   * @return listado de certificados
   */
  selectCertificate(): Observable<CertificateSelectionResponse>;

}
